<template>
  <div
    :style="{ backgroundColor: 'rgba(255, 255, 255, 0.5)', position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }"
  />
</template>

<script>
export default {
  name: 'Overlay',
}
</script>
